define([
  "jquery",
  "local-storage",
  "js-cookie",
  "globals",
  "postal",
], function ($, LocalStorage, cookies, globals, postal) {
  var localStorage = new LocalStorage();
  var lowestPriceDollars = $("#ft-product-price-dollars").html();
  var lowestPriceCents = $("#ft-product-price-cents").html();
  var hasPromo = $("#ft-product-strike-out-price").length > 0;
  if (hasPromo) {
    var lowestStrikeOutPrice = $("#ft-product-strike-out-price").html();
  }

  $("select").change(updatePriceFromServer);
  postal.subscribe({ channel: "productpage", topic: "swatch.selection.changed", callback: updateMainPrice });

  function updateMainPrice() {
    var $selectedSwatch = $(".ft-swatch-selected");
    var priceDollars, priceCents, strikeOutPrice;

    if ($selectedSwatch.length) {
      priceDollars = $selectedSwatch.find(".ft-swatch-price-dollars").html();
      priceCents = $selectedSwatch.find(".ft-swatch-price-cents").html();
      if (hasPromo) {
        strikeOutPrice = $selectedSwatch.find(".ft-swatch-price").attr("data-regular-price");
      }
    } else {
      priceDollars = lowestPriceDollars;
      priceCents = lowestPriceCents;
      strikeOutPrice = lowestStrikeOutPrice;
    }

    if (hasPromo) {
      $("#ft-product-strike-out-price").html(strikeOutPrice);
    }

    $("#ft-product-price-dollars").html(priceDollars);
    $("#ft-product-price-cents sup").html(priceCents);
  }

  function checkForMaxDimensionAndFixIt(dimensionWhole, dimensionEighths, maxDimension, dimension) {
    var nodesToRemove = [];
    if (dimensionWhole >= Math.floor(maxDimension)) {
      _.each($("#ft-product-" + dimension + "-eighths")[0].options, function (option) {
        if (option.value > maxDimension % 1) {
          nodesToRemove.push(option);
        }
      });
      _.each(nodesToRemove, function (node) {
        $(node).remove();
      });
    }
    else if ($("#ft-product-" + dimension + "-eighths")[0].options.length !== 8) {
      var allValues = [{ name: "1/8", value: 0.125 }, { name: "1/4", value: .25 }, { name: "3/8", value: .375 }, { name: "1/2", value: .5 }, { name: "5/8", value: .625 }, { name: "3/4", value: .75 }, { name: "7/8", value: .875 }]
      _.each(allValues, function (option) {
        $("#ft-product-" + dimension + "-eighths").append('<option val="' + option.value + '">' + option.name + '</option>');
      });
    }
  };

  function splitDollarsAndCents(price) {
    var splitLowestPrice = price.toFixed(2).split(".");
    var dollars = "$" + splitLowestPrice[0];
    var cents = "." + splitLowestPrice[1];

    return {
      dollars: dollars,
      cents: cents
    };
  }

  function setPriceNotApplicable() {
    lowestPriceDollars = "N/A";
    lowestPriceCents = "";
    lowestStrikeOutPrice = "";
  }

  function updatePriceFromServer() {
    var heightWhole = parseFloat($("#ft-product-height-wholes")[0].value);
    var heightEighths = parseFloat($("#ft-product-height-eighths")[0].value);
    var widthWhole = parseFloat($("#ft-product-width-wholes")[0].value);
    var widthEighths = parseFloat($("#ft-product-width-eighths")[0].value);
    var height = heightEighths + heightWhole;
    var width = widthWhole + widthEighths;
    checkForMaxDimensionAndFixIt(heightWhole, heightEighths, globals.maxHeight, "height");
    checkForMaxDimensionAndFixIt(widthWhole, widthEighths, globals.maxWidth, "width");
    cookies.set("widthz", width);
    cookies.set("hghtz", height);
    localStorage.persist("SELECTED_HEIGHT_STORAGE_KEY", { serializableValue: height });
    localStorage.persist("SELECTED_WIDTH_STORAGE_KEY", { serializableValue: width });
    $.ajax({
      url: globals.paths.loadProductPlusSiteProductPricing,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      data: {
        height: height,
        width: width,
        productId: globals.productId,
        calculateColorChoicePrices: true
      }
    }).done(function (data, status, xhr) {
        if (data.Data.LowestPrice !== null) {
            var splitPrice = splitDollarsAndCents(data.Data.LowestStrikeThroughPrice || data.Data.LowestPrice);
            var isLowestPricePriceGreaterThanZero = data.Data.LowestPrice > 0;
            lowestPriceDollars = isLowestPricePriceGreaterThanZero ? splitPrice.dollars : "N/A";
            lowestPriceCents = isLowestPricePriceGreaterThanZero ? splitPrice.cents : "";
            lowestStrikeOutPrice = "$" + data.Data.LowestPrice.toFixed(2);

            postal.publish({channel: "productpage", topic: "product.price.loaded", data: { price: data.Data.LowestPrice }});

            _.each(data.Data.ColorChoicePrices, function(choicePrice) {
                var splitPrice = splitDollarsAndCents(choicePrice.StrikeThroughPrice || choicePrice.Price);
                var choiceId = choicePrice.ChoiceId;

                var $choiceDiv = $('[data-choice-id="' + choiceId + '"]');
                var isSplitPriceDollarsValid = splitPrice.dollars !== "$0";

                $choiceDiv.find(".ft-swatch-price-dollars").html(isSplitPriceDollarsValid ? splitPrice.dollars : "N/A");
                $choiceDiv.find(".ft-swatch-price-cents sup").html(isSplitPriceDollarsValid ? splitPrice.cents : "");

                if (choicePrice.StrikeThroughPrice) {
                    $choiceDiv.find(".ft-swatch-price").attr("data-regular-price", "$" + choicePrice.Price.toFixed(2));
                }

                if (choicePrice.Price <= 0) {
                    $choiceDiv.find(".ft-swatch-price").addClass("ft-swatch-unavailable");
                } else {
                    $choiceDiv.find(".ft-swatch-price").removeClass("ft-swatch-unavailable");
                }
            });

            updateMainPrice();
            xhr.status = "success";
        } else {
            setPriceNotApplicable();
        }
    }).fail(function () {
      setPriceNotApplicable();
    });
  }
});